import { Directive, HostListener, inject, input } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { Customer360Drawer } from './customer-360.drawer';
import { Customer360DrawerData } from './models/customer-360.types';

/**
 * Attribute directive that opens the Customer 360 drawer when the host
 * element is clicked. Designed as a no-modification integration point:
 * any *new* template that wants to surface the drawer (v2 user
 * selection modal, new calendar toolbar button, etc.) can apply
 * `[beautyappCustomer360Trigger]="userId"` without touching existing
 * components.
 *
 * Width is 90vw per the plan, capped at 1200px so it remains readable
 * on ultra-wide monitors. The drawer itself has `nzMaskClosable=true`
 * so users can dismiss quickly.
 */
@Directive({
  selector: '[beautyappCustomer360Trigger]',
  standalone: true,
})
export class Customer360TriggerDirective {
  private drawer = inject(NzDrawerService);

  /** The userId (customer id) whose 360 view should open. */
  beautyappCustomer360Trigger = input.required<string>();

  /** Optional pre-filled name + mobile so the header renders immediately. */
  customer360Name = input<string>();
  customer360Mobile = input<string>();

  @HostListener('click', ['$event'])
  onClick(ev: Event): void {
    ev.stopPropagation();
    const userId = this.beautyappCustomer360Trigger();
    if (!userId) return;
    this.drawer.create<
      Customer360Drawer,
      Customer360DrawerData
    >({
      nzContent: Customer360Drawer,
      nzTitle: 'მომხმარებლის პროფილი',
      nzWidth: 'min(90vw, 1200px)',
      nzPlacement: 'right',
      nzMaskClosable: true,
      nzData: {
        userId,
        userFullName: this.customer360Name(),
        userMobile: this.customer360Mobile(),
      },
    });
  }
}
